import Styles from './CollabItemActions.module.scss'
import { ReactComponent as AcceptIcon } from './icons/accept.svg'
import { ReactComponent as RejectIcon } from './icons/reject.svg'
import { IconButton } from 'components/IconButton/IconButton'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { CollabItemActionsProps } from './Types'

export const CollabItemActions = ({
  item,
  onAccept,
  onReject,
  isAcceptDisabled = false,
  isRejectDisabled = false,
  canAcceptItems = false,
  canRejectItems = false,
}: CollabItemActionsProps) => {
  return (
    <div className={Styles.actions}>
      <Tooltip
        label={canRejectItems ? 'Reject' : "You don't have access to reject"}
        placement="top"
        mouseEnterDelay={0.5}
      >
        <div>
          <IconButton
            isDisabled={isRejectDisabled}
            className={Styles.reject}
            icon={RejectIcon}
            aria-label="Reject"
            onPress={() => onReject(item.uuid)}
            data-heap-id="collab-item-reject-one"
          />
        </div>
      </Tooltip>
      <Tooltip
        label={canAcceptItems ? 'Accept' : "You don't have access to accept"}
        placement="top"
        mouseEnterDelay={0.5}
      >
        <div>
          <IconButton
            isDisabled={isAcceptDisabled}
            className={Styles.accept}
            icon={AcceptIcon}
            aria-label="Accept"
            onPress={() => onAccept([item.uuid])}
            data-heap-id="collab-item-accept-one"
          />
        </div>
      </Tooltip>
    </div>
  )
}
